__turbopack_context__.v({
  "checkAllLink": "StoreList-module-scss-module__NypNUW__checkAllLink",
  "emptyBody": "StoreList-module-scss-module__NypNUW__emptyBody",
  "header": "StoreList-module-scss-module__NypNUW__header",
  "list": "StoreList-module-scss-module__NypNUW__list",
  "root": "StoreList-module-scss-module__NypNUW__root",
  "title": "StoreList-module-scss-module__NypNUW__title",
  "titleGroup": "StoreList-module-scss-module__NypNUW__titleGroup",
});
